

import "../Foundation/stylable/colors.st.css.js";
import { classesRuntime, statesRuntime } from "./../stylable-esm-runtime.js";



var _namespace_ = "wds_1_220_3_SidePanel";
var _style_ = classesRuntime.bind(null, _namespace_);

export var cssStates = statesRuntime.bind(null, _namespace_);
export var style = _style_;
export var st = _style_;

export var namespace = _namespace_;
export var classes = {"root":"wds_1_220_3_SidePanel__root"};
export var keyframes = {}; 
export var layers = {};
export var containers = {};
export var stVars = {}; 
export var vars = {"wds-side-panel-floating-border-radius":"--wds-side-panel-floating-border-radius","wds-side-panel-floating-max-height":"--wds-side-panel-floating-max-height","wds-color-fill-surface-overlay":"--wds-color-fill-surface-overlay","wds-shadow-surface-overlay":"--wds-shadow-surface-overlay"}; 




